import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, Query, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';

export type EInvoiceReceivedDownloadHeadersLastSuccessDateItem = EInvoiceReceivedDownloadHeadersLastSuccessDateItemDTO;

class EInvoiceReceivedDownloadHeadersLastSuccessDateItemDTO {
    @Transform(transformDTODate, { toClassOnly: true }) public date?: Date;
}

export class EInvoiceReceivedDownloadHeadersLastSuccessDateQuery extends Query<EInvoiceReceivedDownloadHeadersLastSuccessDateItem> { }
@Injectable({ providedIn: 'root'})
@QueryHandlerFor(EInvoiceReceivedDownloadHeadersLastSuccessDateQuery)
export class EInvoiceReceivedDownloadHeadersLastSuccessDateQueryHandler {
    #Url = TaggedUrl.join('eInvoices/headers/tasks/last-success-date', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(_: EInvoiceReceivedDownloadHeadersLastSuccessDateQuery): Promise<EInvoiceReceivedDownloadHeadersLastSuccessDateItem> {
        const { data } = await this.#http.get<EInvoiceReceivedDownloadHeadersLastSuccessDateItemDTO>(this.#Url, { dto: EInvoiceReceivedDownloadHeadersLastSuccessDateItemDTO });
        return data;
    }
}
